import { Injectable, Injector } from '@angular/core';
import { IBitfApiRequest } from '@common/interfaces';
import { BitfFormItemConfig } from '@common/libs/bitforce/core/models';
import { BitfApiService } from '@common/libs/bitforce/core/services/api/bitf-api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class RidePassengersReportsService extends BitfApiService {
  constructor(public injector: Injector) {
    super('ride-passengers-reports', injector);
  }

  getFormItemsConfig(requestParams: IBitfApiRequest = {}): Observable<BitfFormItemConfig> {
    return this.getRel<BitfFormItemConfig>({
      ...requestParams,
      relation: 'form-item-config',
    }).pipe(
      map(response => {
        return response.content;
      })
    );
  }
}
